'use es6';

/* eslint-disable */
export function fetchTreatment(r, a, o, t, onResolve, e = [], n = {}) {
  window.laboratory = window.laboratory || {
    q: [],
    ready: r => laboratory.q.push(r)
  };
  var p = a.createElement(o);
  p.defer = !0;
  var l = new URLSearchParams();
  e.forEach(r => l.append('treatment_keys', r)), n.userId && l.append('user', n.user), n.portalId && l.append('portal', n.portal), n.utk && l.append('utk', n.utk), n.portalUser && l.append('portal_user', n.portalUser), n.other && l.append('other', n.other);
  var s = l.toString();
  p.src = t + (s ? '?' + s : '');
  var d = a.getElementsByTagName(o)[0];
  d.parentNode.insertBefore(p, d), p.onload = function () {
    laboratory.ready = r => r(window.laboratory.client), laboratory.q.forEach(r => r(window.laboratory.client)), laboratory.q.length = 0;
    window.laboratory.ready(client => {
      client.resolve(onResolve);
    });
  };
}